// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/imgs/home-bg-img.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-one {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  transition: all 200ms ease-in-out;
  cursor: pointer;
  height: 80vh; }

/* For smaller devices */
@media (max-width: 768px) {
  .section-one {
    height: 60vh;
    background-size: contain;
    background-position: center; } }

/* For extra small devices */
@media (max-width: 480px) {
  .section-one {
    height: 50vh;
    background-size: cover;
    background-position: center; } }

.section-two {
  background: transparent linear-gradient(237deg, #1f43db 0%, #1f43db 45%, #001faa 100%) 0% 0% no-repeat padding-box; }

.section-four {
  background: transparent linear-gradient(46deg, #1f43db 0%, #1f43db 18%, #001faa 100%) 0% 0% no-repeat padding-box;
  margin-top: 6rem; }

.section-five {
  background: transparent linear-gradient(119deg, #1d1d1b 0%, #3f3f3a 100%) 0% 0% no-repeat padding-box; }

.section-six {
  background: transparent linear-gradient(119deg, #c8d0f7 0%, #ffffff 100%) 0% 0% no-repeat padding-box; }

.section-seven {
  background: transparent linear-gradient(228deg, #1d1d1b 0%, #3f3f3a 100%) 0% 0% no-repeat padding-box; }

.section-eight {
  background: transparent linear-gradient(228deg, #c1cbf6 0%, #c0e7001a 100%) 0% 0% no-repeat padding-box; }

.section-nine {
  background: #ffffff; }

.why-choose {
  position: relative; }

.why-choose img {
  display: none; }

.why-choose:hover {
  background: #000000;
  transition: all 200ms ease-in-out;
  cursor: pointer; }

.why-choose:hover p {
  color: #ffffff; }

.why-choose:hover img {
  display: block;
  transition: all 200ms ease-in-out; }

.ent-light {
  transition: all 500ms ease-in-out;
  visibility: visible;
  opacity: 1; }

.ent-blue {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear; }

.section-one:hover .ent-light {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear; }

.section-one:hover .ent-blue {
  transition: all 500ms ease-in-out;
  visibility: visible;
  opacity: 1; }

.linked-in {
  position: absolute;
  height: 32px;
  width: 32px;
  background: #EAEAEA;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: bold;
  border-radius: 50%;
  bottom: -10%;
  transition: all 100ms ease-in-out;
  padding-top: 2px;
  margin: 0px auto;
  left: 0;
  right: 0; }

.linked-in:hover {
  background: #1F43DB;
  color: #ffffff; }
`, "",{"version":3,"sources":["webpack://./src/views/styles.scss"],"names":[],"mappings":"AAAA;EACE,yDAAuD;EACvD,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,iCAAiC;EACjC,eAAe;EACf,YAAY,EAAA;;AAGd,wBAAA;AACA;EACE;IACE,YAAY;IACZ,wBAAwB;IACxB,2BAA2B,EAAA,EAC5B;;AAGH,4BAAA;AACA;EACE;IACE,YAAY;IACZ,sBAAsB;IACtB,2BAA2B,EAAA,EAC5B;;AAIH;EACE,kHAEuB,EAAA;;AAGzB;EACE,iHAEuB;EACvB,gBAAgB,EAAA;;AAGlB;EACE,qGAC0B,EAAA;;AAG5B;EACE,qGAC0B,EAAA;;AAG5B;EACE,qGAC0B,EAAA;;AAG5B;EACE,uGAC0B,EAAA;;AAG5B;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB,EAAA;;AAGpB;EACE,aAAa,EAAA;;AAGf;EACE,mBAAmB;EACnB,iCAAiC;EACjC,eAAe,EAAA;;AAGjB;EACE,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,iCAAiC,EAAA;;AAGnC;EACE,iCAAiC;EACjC,mBAAmB;EACnB,UAAU,EAAA;;AAGZ;EAIE,kBAAkB;EAClB,UAAU;EACV,8CAA8C,EAAA;;AAGhD;EACE,kBAAkB;EAClB,UAAU;EACV,8CAA8C,EAAA;;AAGhD;EACE,iCAAiC;EACjC,mBAAmB;EACnB,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,OAAO;EACP,QAAQ,EAAA;;AAGV;EACE,mBAAmB;EACnB,cAAc,EAAA","sourcesContent":[".section-one {\n  background-image: url(\"../assets/imgs/home-bg-img.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  transition: all 200ms ease-in-out;\n  cursor: pointer;\n  height: 80vh;\n}\n\n/* For smaller devices */\n@media (max-width: 768px) {\n  .section-one {\n    height: 60vh; \n    background-size: contain; \n    background-position: center;\n  }\n}\n\n/* For extra small devices */\n@media (max-width: 480px) {\n  .section-one {\n    height: 50vh; \n    background-size: cover; \n    background-position: center;\n  }\n}\n\n\n.section-two {\n  background: transparent\n    linear-gradient(237deg, #1f43db 0%, #1f43db 45%, #001faa 100%) 0% 0%\n    no-repeat padding-box;\n}\n\n.section-four {\n  background: transparent\n    linear-gradient(46deg, #1f43db 0%, #1f43db 18%, #001faa 100%) 0% 0%\n    no-repeat padding-box;\n  margin-top: 6rem;\n}\n\n.section-five {\n  background: transparent linear-gradient(119deg, #1d1d1b 0%, #3f3f3a 100%) 0%\n    0% no-repeat padding-box;\n}\n\n.section-six {\n  background: transparent linear-gradient(119deg, #c8d0f7 0%, #ffffff 100%) 0%\n    0% no-repeat padding-box;\n}\n\n.section-seven {\n  background: transparent linear-gradient(228deg, #1d1d1b 0%, #3f3f3a 100%) 0%\n    0% no-repeat padding-box;\n}\n\n.section-eight {\n  background: transparent linear-gradient(228deg, #c1cbf6 0%, #c0e7001a 100%) 0%\n    0% no-repeat padding-box;\n}\n\n.section-nine {\n  background: #ffffff;\n}\n\n.why-choose {\n  position: relative;\n}\n\n.why-choose img {\n  display: none;\n}\n\n.why-choose:hover {\n  background: #000000;\n  transition: all 200ms ease-in-out;\n  cursor: pointer;\n}\n\n.why-choose:hover p {\n  color: #ffffff;\n}\n\n.why-choose:hover img {\n  display: block;\n  transition: all 200ms ease-in-out;\n}\n\n.ent-light {\n  transition: all 500ms ease-in-out;\n  visibility: visible;\n  opacity: 1;\n}\n\n.ent-blue {\n  // transition: all 500ms ease-in-out;\n  // display: none;\n\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.5s linear;\n}\n\n.section-one:hover .ent-light {\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.5s linear;\n}\n\n.section-one:hover .ent-blue {\n  transition: all 500ms ease-in-out;\n  visibility: visible;\n  opacity: 1;\n}\n\n.linked-in {\n  position: absolute;\n  height: 32px;\n  width: 32px;\n  background: #EAEAEA;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 13px;\n  font-weight: bold;\n  border-radius: 50%;\n  bottom: -10%;\n  transition: all 100ms ease-in-out;\n  padding-top: 2px;\n  margin: 0px auto;\n  left: 0;\n  right: 0;\n}\n\n.linked-in:hover {\n  background: #1F43DB;\n  color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
